import * as React from 'react'
import { Switch } from '@/components/ui/switch'
import { cn } from '@/lib/utils'
import { OdinFormLabel } from '@/components/ui/odin/form/odin-form-label'
import { OdinFormDescription } from '@/components/ui/odin/form/odin-form-description'

export type OdinToggleProps = {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  label?: string
  description?: string
  disabled?: boolean
  className?: string
}

// Labeled toggle row over the raw Switch: text on the left, switch on the right.
export function OdinToggle({ checked, onCheckedChange, label, description, disabled, className }: OdinToggleProps) {
  const id = React.useId()
  return (
    <div className={cn('flex items-start justify-between gap-4', className)}>
      {(label || description) && (
        <div className="flex flex-col gap-1">
          {label && <OdinFormLabel htmlFor={id}>{label}</OdinFormLabel>}
          {description && <OdinFormDescription>{description}</OdinFormDescription>}
        </div>
      )}
      <Switch id={id} checked={checked} onCheckedChange={(value) => onCheckedChange(value)} disabled={disabled} />
    </div>
  )
}
